import { Button, ButtonVariants } from '../../components/primitives';
import Alert from '../../components/ui/Alert';
import ContactSupport from '../../components/ui/ContactSupport';
import { testId } from '../../utils';
import { PageCard } from './PageCard';
import { Cornerstone } from '@rpi/api';
import { Trans, useTranslation } from '@rpi/i18n';
import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

export const ExpiredVerification: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const email = React.useMemo(() => {
    const emailParam = searchParams.get('email');

    if (emailParam === null || emailParam === '') {
      throw new Error('Missing email');
    }

    return emailParam;
  }, [searchParams]);

  const { t } = useTranslation(undefined, { keyPrefix: 'route.auth' });

  const [error, setError] = React.useState(false);
  const [successful, setSuccessful] = React.useState(false);

  const { mutate } = Cornerstone.useRequestRegistrationToken({
    mutation: {
      onSuccess() {
        setError(false);
        setSuccessful(true);
      },
      onError(error: any) {
        setSuccessful(false);
        const errorCode = (error as any)?.response?.data?.detail as
          | string
          | undefined;

        if (errorCode === Cornerstone.ErrorCode.USER_ALREADY_REGISTERED) {
          searchParams.set('alreadyRegistered', 'true');
          navigate(`/auth/sign-in?${searchParams.toString()}`);
        }

        setError(true);
      },
    },
  });

  const onResend = React.useCallback(() => {
    mutate({
      data: {
        email,
      },
    });
  }, [email, mutate]);

  return (
    <PageCard className="text-gray-soft">
      {error && (
        <Alert {...testId('error')} variant="error">
          {t('expired_verification_resend_error')}
        </Alert>
      )}
      {successful && (
        <Alert {...testId('success')} variant="success">
          {t('verification_link_sent')}
        </Alert>
      )}
      <h1 className="text-medium font-bold text-center mb-6">
        {t('expired_verification_title')}
      </h1>
      <div className="text-center">
        <div className="mb-6">
          <Trans i18nKey={t('expired_verification_prompt')} />
        </div>
        <Button
          {...testId('submit')}
          variant={ButtonVariants.Secondary}
          type="submit"
          className="w-full font-semibold mb-6"
          onClick={onResend}
        >
          {t('resend')}
        </Button>
        <Trans
          className="mt-6"
          i18nKey={t('expired_verification_missing_email')}
        />
        <ContactSupport />
      </div>
    </PageCard>
  );
};
